import OapPageNavigation from './code/Scripts/components/OapPageNavigation.vue';
import OapPageNavigationForColorsonic from './code/Scripts/components/OapPageNavigationForColorsonic.vue';

export default {
  components: {
    OapPageNavigation,
    OapPageNavigationForColorsonic,
  },
};
